import './instrument';

import {
  type AuthenticationResult,
  type EventMessage,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import '@lego/connect-theme-enterprise';
import '@lego/connect-utilities/index.css';
import { reactErrorHandler } from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { msalConfig } from './authConfig';

const ele = document.getElementById('root');
if (!ele) {
  throw new Error('Root element not found');
}

// Force light mode for Connect, to avoid dark mode colors
document.body.setAttribute('data-mode', 'light');

export const msalInstance = new PublicClientApplication(msalConfig);

// Set active account on successful login
msalInstance.addEventCallback((message: EventMessage) => {
  if (
    message.eventType === EventType.LOGIN_SUCCESS &&
    message.payload !== undefined
  ) {
    const payload = message.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  }
});

msalInstance.initialize().then(() => {
  createRoot(ele, {
    onUncaughtError: reactErrorHandler(),
    onCaughtError: reactErrorHandler(),
    onRecoverableError: reactErrorHandler(),
  }).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>,
  );
});
